import React, { Component } from 'react';
import { i18n } from '@ecster/i18n';
import { UserMessagePanel, Message, Panel, PanelContent, LabelValue } from '@ecster/components';
import { walletIcon } from '@ecster/icons/H80/green';

import PropTypes from 'prop-types';

import InvoiceInfoPanel from '../components/InvoiceInfoPanel';
import { getBillProperties } from '../util';
import { formatAmount, formatNumber } from '../../../common/util/format.js';

export class AccountInvoicePageContent extends Component {
    static propTypes = {
        account: PropTypes.object.isRequired,
        bill: PropTypes.object.isRequired,
        accountTerms: PropTypes.object.isRequired,
        accountRef: PropTypes.string.isRequired,
    };

    render() {
        const { account, bill, accountRef, accountTerms } = this.props;

        const billProps = getBillProperties(bill, account);
        const accountTxUrl = `#/account/${accountRef}/transactions`;

        const monthlyInterestFormatted = formatNumber(accountTerms && accountTerms.interestRate / 12);

        const costPer1000Formatted =
            accountTerms &&
            formatAmount((1000 * accountTerms.interestRate) / 12, {
                strip00: true,
                roundUp: true,
            });

        const lowestAmountFormatted = formatAmount(billProps.lab1, { strip00: true, decimals: 2 });

        const lowestAmountInfo = (
            <>
                <p className="text-[14px] my-1">Lägsta belopp du kan välja att betala är {lowestAmountFormatted}.</p>
                <p className="text-[13px] my-1">
                    Det tillkommer {monthlyInterestFormatted}% ränta per månad på hela din skuld, vilket motsvarar ca{' '}
                    {costPer1000Formatted} per 1000-lapp.
                </p>
            </>
        );

        return (
            <>
                {!billProps.hasBill && (
                    <UserMessagePanel
                        icon={walletIcon}
                        header={i18n('invoice.account-invoice.no-invoice.header')}
                        body={i18n('invoice.account-invoice.no-invoice.info', 'p', {
                            url: accountTxUrl,
                        })}
                    />
                )}
                {(billProps.hasBill || billProps.isZeroInvoice) && (
                    <InvoiceInfoPanel
                        account={account}
                        bill={bill}
                        accountRef={accountRef}
                        lab1={billProps.lab1}
                        lab2={billProps.lab2}
                        lab3={billProps.lab3}
                    />
                )}
                {billProps.lab3LtUsed && (
                    <Panel paddingTopBottom="xLarge" stretchInMobile>
                        <PanelContent wide className="centered-content">
                            <h2 className="h3">Varje krona räknas!</h2>
                            <p>
                                Vill du betala mer denna månad? Genom att betala in mer varje månad snabbar du på
                                återbetalningen och minskar dina kostnader. Du kan även lösa krediten i förtid.
                            </p>
                        </PanelContent>
                        <PanelContent narrow>
                            <LabelValue
                                label="Snabbare återbetalning - betala mer än"
                                value={formatAmount(billProps.lab3, { decimals: 0 })}
                            />
                            <LabelValue
                                label="Betala hela skulden"
                                value={formatAmount(account.used, { strip00: true, decimals: 2 })}
                            />
                            <p>&nbsp;</p>
                            {lowestAmountInfo}
                        </PanelContent>
                    </Panel>
                )}
                {billProps.lab3EqUsed && (
                    <Panel paddingTopBottom="medium" stretchInMobile>
                        <PanelContent narrow>{lowestAmountInfo}</PanelContent>
                    </Panel>
                )}

                {billProps.isZeroInvoice && (
                    <Message
                        blue
                        header={i18n('invoice.account-invoice.zero-invoice.header')}
                        message={i18n('invoice.account-invoice.zero-invoice.text')}
                    />
                )}
            </>
        );
    }
}
